// A document number that opens its drawer: a real <a> (the guards ask for links, not ghost buttons), styled by .disp-pg .lnk-btn (invoicing.css).
import React from 'react';

export default function DocLink({ children, onOpen, testid }) {
  return <a href="#doc" className="lnk-btn mono" data-testid={testid} onClick={(e) => { e.preventDefault(); onOpen(); }}>{children}</a>;
}
